export function buildInspectionRowFromOrganizationContext(ctx) {
    if (!ctx) return null;
    const ra = ctx.responsibility || {};
    return {
        id: ctx.employeeId,
        first_name: ctx.firstName || '',
        last_name: ctx.lastName || '',
        avatar: ctx.avatar || '',
        email: ctx.email || '',
        access: ctx.access,
        user: {
            id: ctx.employeeId,
            name: ctx.employeeName || `${ctx.firstName || ''} ${ctx.lastName || ''}`.trim(),
            email: ctx.email || '',
            avatar: ctx.avatar || null,
            position: ctx.jobTitle || ctx.primaryPositionName || '',
        },
        responsibilityAssignments: {
            responsibility_id: ctx.responsibilityId || ra.responsibilityId || '',
            responsibility_code: ra.responsibilityCode || '',
            responsibility_name: ra.responsibilityName || '',
            responsibility_importance: ra.responsibilityImportance ?? 3,
            role_code: ra.roleCode || '',
            role_name: ra.roleName || '',
            role_importance: ra.roleImportance ?? 3,
            position_code: ra.positionCode || '',
            position_name: ra.positionName || '',
            position_importance: ra.positionImportance ?? 3,
            position_commitment: ra.positionCommitment || 'Primary',
            assigned_on: ra.assignedOn || null,
            new_duration: ra.newDuration || 15,
        },
        badge: ctx.badge || {
            id: null,
            level: 'Novice',
            status: 'No Dot',
            checkpoints: [],
        },
        checkpointCounts: ctx.checkpointCounts || {},
        originalEmployee: {
            id: ctx.employeeId,
            employee_id: ctx.employeeId,
            first_name: ctx.firstName || '',
            last_name: ctx.lastName || '',
            avatar: ctx.avatar || '',
            email: ctx.email || '',
            access: ctx.access,
            title: ctx.jobTitle || '',
            primary_position: { name: ctx.primaryPositionName || '' },
            preparing_for_position: { name: ctx.preparingForPositionName || '' },
            preparing_for_positions: ctx.preparingForPositionName
                ? [{ name: ctx.preparingForPositionName }]
                : [],
        },
    };
}
